import OptionsPanel from "components/panels/OptionsPanel";
import Axios from "axios";
import React from "react";
import { downloadFile } from "utilities/apiUtils";
import { ButtonPrimary, ButtonSecondary } from "components/Atoms/Button";
import { Message } from "semantic-ui-react";
import { Loading } from "components/panels";

interface ExportPanelProps {
  isLoading: boolean;
  errors: server.dto.ApiError[];
  count: number;
  dto: server.dto.ExportItineraryInstruction;
}

export const ExportPanel = (props: ExportPanelProps) => {
  const [isDownloadingExtension, setIsDownloadingExtension] = React.useState<"pdf" | "docx" | null>(null);
  const canExport = props.count > 0 && props.errors.length === 0;

  const getTitle = (): string => {
    if (canExport) {
      return props.count === 1 ? `1 ${RESX.Appointment.resxAppointment}` : `${props.count} ${RESX.Appointment.Appointments}`;
    }

    return RESX.File.Download;
  };

  const downloadItinerary = async (extension: "pdf" | "docx") => {
    setIsDownloadingExtension(extension);
    const fileBlobRes = await Axios.post(
      window.CoreApi.Itinerary.Export.absoluteUrl("itinerary." + extension),
      props.dto,
      {
        responseType: "blob",
        withCredentials: true
      });

    setIsDownloadingExtension(null);
    downloadFile(fileBlobRes.data, "itinerary." + extension);
  };

  return <OptionsPanel title={getTitle()}>
    {props.isLoading && <div className="flex-column gap">
      <Loading />
    </div>}
    {!props.isLoading && <div className="flex-column gap">
      {!canExport &&
        <Message color="yellow">
          {props.errors.length > 0 && props.errors[0].message}
          {(props.errors.length === 0 && props.count === 0) && RESX.Appointment.NoAppoinmentsInSelection}
        </Message>}
      {canExport && <>
        <ButtonPrimary
          loading={isDownloadingExtension === "pdf"}
          disabled={isDownloadingExtension === "docx"}
          onClick={() => downloadItinerary("pdf")}
          label={`${RESX.File.Download} PDF`}
        />
        <ButtonSecondary
          loading={isDownloadingExtension === "docx"}
          disabled={isDownloadingExtension === "pdf"}
          onClick={() => downloadItinerary("docx")}
          label={`${RESX.File.Download} DOCX`}
        />
      </>}
    </div>}
  </OptionsPanel>
}